var cov_k5j169vhi = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Dropdown/index.tsx",
      hash = "86f1b7e28eb088108708e84f3270f5b49595b4b3",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Dropdown/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 20,
          column: 20
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "1": {
        start: {
          line: 32,
          column: 21
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "2": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 16
        }
      },
      "3": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 71,
          column: 5
        }
      },
      "4": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 76,
          column: 5
        }
      },
      "5": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 89
        }
      },
      "6": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 47
        }
      },
      "7": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 50
        }
      },
      "8": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 46
        }
      },
      "9": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 50
        }
      },
      "10": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 48
        }
      },
      "11": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 62
        }
      },
      "12": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 63
        }
      },
      "13": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 48
        }
      },
      "14": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 19
        }
      },
      "15": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 29
        }
      },
      "16": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 23
        }
      },
      "17": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 23
        }
      },
      "18": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 32
        }
      },
      "19": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 35
        }
      },
      "20": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 109,
          column: 5
        }
      },
      "21": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 108,
          column: 30
        }
      },
      "22": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 26
        }
      },
      "23": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 119,
          column: 7
        }
      },
      "24": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 119,
          column: 7
        }
      },
      "25": {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 116,
          column: 38
        }
      },
      "26": {
        start: {
          line: 117,
          column: 13
        },
        end: {
          line: 119,
          column: 7
        }
      },
      "27": {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 118,
          column: 39
        }
      },
      "28": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 30
        }
      },
      "29": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 49
        }
      },
      "30": {
        start: {
          line: 125,
          column: 35
        },
        end: {
          line: 125,
          column: 49
        }
      },
      "31": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 29
        }
      },
      "32": {
        start: {
          line: 130,
          column: 23
        },
        end: {
          line: 130,
          column: 33
        }
      },
      "33": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 132,
          column: 44
        }
      },
      "34": {
        start: {
          line: 132,
          column: 29
        },
        end: {
          line: 132,
          column: 44
        }
      },
      "35": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 43
        }
      },
      "36": {
        start: {
          line: 133,
          column: 23
        },
        end: {
          line: 133,
          column: 43
        }
      },
      "37": {
        start: {
          line: 134,
          column: 25
        },
        end: {
          line: 134,
          column: 39
        }
      },
      "38": {
        start: {
          line: 135,
          column: 24
        },
        end: {
          line: 135,
          column: 37
        }
      },
      "39": {
        start: {
          line: 136,
          column: 17
        },
        end: {
          line: 136,
          column: 53
        }
      },
      "40": {
        start: {
          line: 137,
          column: 19
        },
        end: {
          line: 137,
          column: 70
        }
      },
      "41": {
        start: {
          line: 138,
          column: 19
        },
        end: {
          line: 138,
          column: 66
        }
      },
      "42": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 67
        }
      },
      "43": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 141,
          column: 19
        }
      },
      "44": {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 145,
          column: 21
        }
      },
      "45": {
        start: {
          line: 149,
          column: 26
        },
        end: {
          line: 149,
          column: 36
        }
      },
      "46": {
        start: {
          line: 150,
          column: 21
        },
        end: {
          line: 150,
          column: 57
        }
      },
      "47": {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 152,
          column: 99
        }
      },
      "48": {
        start: {
          line: 152,
          column: 62
        },
        end: {
          line: 152,
          column: 98
        }
      },
      "49": {
        start: {
          line: 156,
          column: 19
        },
        end: {
          line: 156,
          column: 68
        }
      },
      "50": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 85
        }
      },
      "51": {
        start: {
          line: 161,
          column: 25
        },
        end: {
          line: 161,
          column: 35
        }
      },
      "52": {
        start: {
          line: 162,
          column: 15
        },
        end: {
          line: 162,
          column: 54
        }
      },
      "53": {
        start: {
          line: 163,
          column: 19
        },
        end: {
          line: 165,
          column: 56
        }
      },
      "54": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 166,
          column: 71
        }
      },
      "55": {
        start: {
          line: 166,
          column: 65
        },
        end: {
          line: 166,
          column: 71
        }
      },
      "56": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 167,
          column: 22
        }
      },
      "57": {
        start: {
          line: 171,
          column: 27
        },
        end: {
          line: 171,
          column: 37
        }
      },
      "58": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 174,
          column: 5
        }
      },
      "59": {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 173,
          column: 35
        }
      },
      "60": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 175,
          column: 25
        }
      },
      "61": {
        start: {
          line: 175,
          column: 19
        },
        end: {
          line: 175,
          column: 25
        }
      },
      "62": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 36
        }
      },
      "63": {
        start: {
          line: 176,
          column: 20
        },
        end: {
          line: 176,
          column: 36
        }
      },
      "64": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 179,
          column: 6
        }
      },
      "65": {
        start: {
          line: 183,
          column: 27
        },
        end: {
          line: 183,
          column: 37
        }
      },
      "66": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 187,
          column: 13
        }
      },
      "67": {
        start: {
          line: 185,
          column: 6
        },
        end: {
          line: 185,
          column: 39
        }
      },
      "68": {
        start: {
          line: 185,
          column: 22
        },
        end: {
          line: 185,
          column: 39
        }
      },
      "69": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 36
        }
      },
      "70": {
        start: {
          line: 191,
          column: 25
        },
        end: {
          line: 191,
          column: 35
        }
      },
      "71": {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 192,
          column: 33
        }
      },
      "72": {
        start: {
          line: 192,
          column: 27
        },
        end: {
          line: 192,
          column: 33
        }
      },
      "73": {
        start: {
          line: 194,
          column: 4
        },
        end: {
          line: 194,
          column: 45
        }
      },
      "74": {
        start: {
          line: 194,
          column: 39
        },
        end: {
          line: 194,
          column: 45
        }
      },
      "75": {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 198,
          column: 28
        }
      },
      "76": {
        start: {
          line: 197,
          column: 6
        },
        end: {
          line: 197,
          column: 24
        }
      },
      "77": {
        start: {
          line: 198,
          column: 11
        },
        end: {
          line: 198,
          column: 28
        }
      },
      "78": {
        start: {
          line: 202,
          column: 53
        },
        end: {
          line: 202,
          column: 63
        }
      },
      "79": {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 215,
          column: 5
        }
      },
      "80": {
        start: {
          line: 204,
          column: 6
        },
        end: {
          line: 214,
          column: 7
        }
      },
      "81": {
        start: {
          line: 216,
          column: 4
        },
        end: {
          line: 229,
          column: 5
        }
      },
      "82": {
        start: {
          line: 233,
          column: 63
        },
        end: {
          line: 233,
          column: 73
        }
      },
      "83": {
        start: {
          line: 234,
          column: 16
        },
        end: {
          line: 234,
          column: 23
        }
      },
      "84": {
        start: {
          line: 235,
          column: 28
        },
        end: {
          line: 235,
          column: 97
        }
      },
      "85": {
        start: {
          line: 236,
          column: 26
        },
        end: {
          line: 236,
          column: 57
        }
      },
      "86": {
        start: {
          line: 238,
          column: 6
        },
        end: {
          line: 240,
          column: 13
        }
      },
      "87": {
        start: {
          line: 242,
          column: 19
        },
        end: {
          line: 247,
          column: 5
        }
      },
      "88": {
        start: {
          line: 248,
          column: 4
        },
        end: {
          line: 250,
          column: 5
        }
      },
      "89": {
        start: {
          line: 249,
          column: 6
        },
        end: {
          line: 249,
          column: 22
        }
      },
      "90": {
        start: {
          line: 251,
          column: 4
        },
        end: {
          line: 262,
          column: 5
        }
      },
      "91": {
        start: {
          line: 252,
          column: 6
        },
        end: {
          line: 261,
          column: 7
        }
      },
      "92": {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 276,
          column: 5
        }
      },
      "93": {
        start: {
          line: 280,
          column: 62
        },
        end: {
          line: 280,
          column: 72
        }
      },
      "94": {
        start: {
          line: 281,
          column: 4
        },
        end: {
          line: 281,
          column: 62
        }
      },
      "95": {
        start: {
          line: 281,
          column: 51
        },
        end: {
          line: 281,
          column: 62
        }
      },
      "96": {
        start: {
          line: 282,
          column: 29
        },
        end: {
          line: 282,
          column: 33
        }
      },
      "97": {
        start: {
          line: 283,
          column: 4
        },
        end: {
          line: 344,
          column: 5
        }
      },
      "98": {
        start: {
          line: 300,
          column: 32
        },
        end: {
          line: 300,
          column: 81
        }
      },
      "99": {
        start: {
          line: 301,
          column: 32
        },
        end: {
          line: 305,
          column: 11
        }
      },
      "100": {
        start: {
          line: 309,
          column: 10
        },
        end: {
          line: 313,
          column: 11
        }
      },
      "101": {
        start: {
          line: 310,
          column: 12
        },
        end: {
          line: 310,
          column: 91
        }
      },
      "102": {
        start: {
          line: 312,
          column: 12
        },
        end: {
          line: 312,
          column: 59
        }
      },
      "103": {
        start: {
          line: 314,
          column: 31
        },
        end: {
          line: 314,
          column: 48
        }
      },
      "104": {
        start: {
          line: 315,
          column: 10
        },
        end: {
          line: 339,
          column: 11
        }
      },
      "105": {
        start: {
          line: 348,
          column: 52
        },
        end: {
          line: 348,
          column: 62
        }
      },
      "106": {
        start: {
          line: 350,
          column: 21
        },
        end: {
          line: 350,
          column: 39
        }
      },
      "107": {
        start: {
          line: 352,
          column: 24
        },
        end: {
          line: 355,
          column: 6
        }
      },
      "108": {
        start: {
          line: 356,
          column: 4
        },
        end: {
          line: 356,
          column: 51
        }
      },
      "109": {
        start: {
          line: 356,
          column: 19
        },
        end: {
          line: 356,
          column: 51
        }
      },
      "110": {
        start: {
          line: 358,
          column: 4
        },
        end: {
          line: 369,
          column: 5
        }
      },
      "111": {
        start: {
          line: 373,
          column: 0
        },
        end: {
          line: 373,
          column: 41
        }
      },
      "112": {
        start: {
          line: 375,
          column: 16
        },
        end: {
          line: 375,
          column: 42
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 36
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 66
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 92,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        },
        loc: {
          start: {
            line: 92,
            column: 22
          },
          end: {
            line: 95,
            column: 3
          }
        },
        line: 92
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 97,
            column: 3
          }
        },
        loc: {
          start: {
            line: 97,
            column: 23
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 97
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        loc: {
          start: {
            line: 101,
            column: 25
          },
          end: {
            line: 104,
            column: 3
          }
        },
        line: 101
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 106,
            column: 2
          },
          end: {
            line: 106,
            column: 3
          }
        },
        loc: {
          start: {
            line: 106,
            column: 13
          },
          end: {
            line: 111,
            column: 3
          }
        },
        line: 106
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 113,
            column: 2
          },
          end: {
            line: 113,
            column: 3
          }
        },
        loc: {
          start: {
            line: 113,
            column: 17
          },
          end: {
            line: 121,
            column: 3
          }
        },
        line: 113
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 123,
            column: 2
          },
          end: {
            line: 123,
            column: 3
          }
        },
        loc: {
          start: {
            line: 123,
            column: 15
          },
          end: {
            line: 127,
            column: 3
          }
        },
        line: 123
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 129,
            column: 2
          },
          end: {
            line: 129,
            column: 3
          }
        },
        loc: {
          start: {
            line: 129,
            column: 16
          },
          end: {
            line: 142,
            column: 3
          }
        },
        line: 129
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 144,
            column: 2
          },
          end: {
            line: 144,
            column: 3
          }
        },
        loc: {
          start: {
            line: 144,
            column: 34
          },
          end: {
            line: 146,
            column: 3
          }
        },
        line: 144
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 148,
            column: 2
          },
          end: {
            line: 148,
            column: 3
          }
        },
        loc: {
          start: {
            line: 148,
            column: 13
          },
          end: {
            line: 153,
            column: 3
          }
        },
        line: 148
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 152,
            column: 37
          },
          end: {
            line: 152,
            column: 38
          }
        },
        loc: {
          start: {
            line: 152,
            column: 62
          },
          end: {
            line: 152,
            column: 98
          }
        },
        line: 152
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 155,
            column: 2
          },
          end: {
            line: 155,
            column: 3
          }
        },
        loc: {
          start: {
            line: 155,
            column: 37
          },
          end: {
            line: 158,
            column: 3
          }
        },
        line: 155
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 160,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        loc: {
          start: {
            line: 160,
            column: 33
          },
          end: {
            line: 168,
            column: 3
          }
        },
        line: 160
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 170,
            column: 2
          },
          end: {
            line: 170,
            column: 3
          }
        },
        loc: {
          start: {
            line: 170,
            column: 16
          },
          end: {
            line: 180,
            column: 3
          }
        },
        line: 170
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 182,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        },
        loc: {
          start: {
            line: 182,
            column: 26
          },
          end: {
            line: 188,
            column: 3
          }
        },
        line: 182
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 184,
            column: 33
          },
          end: {
            line: 184,
            column: 34
          }
        },
        loc: {
          start: {
            line: 184,
            column: 39
          },
          end: {
            line: 187,
            column: 5
          }
        },
        line: 184
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 190,
            column: 3
          }
        },
        loc: {
          start: {
            line: 190,
            column: 30
          },
          end: {
            line: 199,
            column: 3
          }
        },
        line: 190
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 201,
            column: 2
          },
          end: {
            line: 201,
            column: 3
          }
        },
        loc: {
          start: {
            line: 201,
            column: 105
          },
          end: {
            line: 230,
            column: 3
          }
        },
        line: 201
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 232,
            column: 2
          },
          end: {
            line: 232,
            column: 3
          }
        },
        loc: {
          start: {
            line: 232,
            column: 39
          },
          end: {
            line: 277,
            column: 3
          }
        },
        line: 232
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 279,
            column: 2
          },
          end: {
            line: 279,
            column: 3
          }
        },
        loc: {
          start: {
            line: 279,
            column: 104
          },
          end: {
            line: 345,
            column: 3
          }
        },
        line: 279
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 299,
            column: 18
          },
          end: {
            line: 299,
            column: 19
          }
        },
        loc: {
          start: {
            line: 299,
            column: 32
          },
          end: {
            line: 340,
            column: 9
          }
        },
        line: 299
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 347,
            column: 2
          },
          end: {
            line: 347,
            column: 3
          }
        },
        loc: {
          start: {
            line: 347,
            column: 11
          },
          end: {
            line: 370,
            column: 3
          }
        },
        line: 347
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        }],
        line: 74
      },
      "1": {
        loc: {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        }, {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        }],
        line: 107
      },
      "2": {
        loc: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 119,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 119,
            column: 7
          }
        }, {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 119,
            column: 7
          }
        }],
        line: 114
      },
      "3": {
        loc: {
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 119,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 119,
            column: 7
          }
        }, {
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 119,
            column: 7
          }
        }],
        line: 115
      },
      "4": {
        loc: {
          start: {
            line: 117,
            column: 13
          },
          end: {
            line: 119,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 117,
            column: 13
          },
          end: {
            line: 119,
            column: 7
          }
        }, {
          start: {
            line: 117,
            column: 13
          },
          end: {
            line: 119,
            column: 7
          }
        }],
        line: 117
      },
      "5": {
        loc: {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 49
          }
        }, {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 49
          }
        }],
        line: 125
      },
      "6": {
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 44
          }
        }, {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 44
          }
        }],
        line: 132
      },
      "7": {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 43
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 43
          }
        }],
        line: 133
      },
      "8": {
        loc: {
          start: {
            line: 137,
            column: 19
          },
          end: {
            line: 137,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 137,
            column: 52
          },
          end: {
            line: 137,
            column: 58
          }
        }, {
          start: {
            line: 137,
            column: 61
          },
          end: {
            line: 137,
            column: 70
          }
        }],
        line: 137
      },
      "9": {
        loc: {
          start: {
            line: 138,
            column: 19
          },
          end: {
            line: 138,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 138,
            column: 50
          },
          end: {
            line: 138,
            column: 57
          }
        }, {
          start: {
            line: 138,
            column: 60
          },
          end: {
            line: 138,
            column: 66
          }
        }],
        line: 138
      },
      "10": {
        loc: {
          start: {
            line: 150,
            column: 34
          },
          end: {
            line: 150,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 150,
            column: 46
          },
          end: {
            line: 150,
            column: 52
          }
        }, {
          start: {
            line: 150,
            column: 55
          },
          end: {
            line: 150,
            column: 56
          }
        }],
        line: 150
      },
      "11": {
        loc: {
          start: {
            line: 156,
            column: 19
          },
          end: {
            line: 156,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 156,
            column: 26
          },
          end: {
            line: 156,
            column: 44
          }
        }, {
          start: {
            line: 156,
            column: 47
          },
          end: {
            line: 156,
            column: 68
          }
        }],
        line: 156
      },
      "12": {
        loc: {
          start: {
            line: 163,
            column: 19
          },
          end: {
            line: 165,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 164,
            column: 74
          }
        }, {
          start: {
            line: 165,
            column: 8
          },
          end: {
            line: 165,
            column: 56
          }
        }],
        line: 163
      },
      "13": {
        loc: {
          start: {
            line: 165,
            column: 8
          },
          end: {
            line: 165,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 165,
            column: 8
          },
          end: {
            line: 165,
            column: 27
          }
        }, {
          start: {
            line: 165,
            column: 31
          },
          end: {
            line: 165,
            column: 56
          }
        }],
        line: 165
      },
      "14": {
        loc: {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 166,
            column: 71
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 166,
            column: 71
          }
        }, {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 166,
            column: 71
          }
        }],
        line: 166
      },
      "15": {
        loc: {
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 166,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 166,
            column: 10
          }
        }, {
          start: {
            line: 166,
            column: 14
          },
          end: {
            line: 166,
            column: 20
          }
        }, {
          start: {
            line: 166,
            column: 24
          },
          end: {
            line: 166,
            column: 63
          }
        }],
        line: 166
      },
      "16": {
        loc: {
          start: {
            line: 172,
            column: 4
          },
          end: {
            line: 174,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 172,
            column: 4
          },
          end: {
            line: 174,
            column: 5
          }
        }, {
          start: {
            line: 172,
            column: 4
          },
          end: {
            line: 174,
            column: 5
          }
        }],
        line: 172
      },
      "17": {
        loc: {
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 175,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 175,
            column: 25
          }
        }, {
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 175,
            column: 25
          }
        }],
        line: 175
      },
      "18": {
        loc: {
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 176,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 176,
            column: 36
          }
        }, {
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 176,
            column: 36
          }
        }],
        line: 176
      },
      "19": {
        loc: {
          start: {
            line: 182,
            column: 13
          },
          end: {
            line: 182,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 182,
            column: 21
          },
          end: {
            line: 182,
            column: 24
          }
        }],
        line: 182
      },
      "20": {
        loc: {
          start: {
            line: 185,
            column: 6
          },
          end: {
            line: 185,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 6
          },
          end: {
            line: 185,
            column: 39
          }
        }, {
          start: {
            line: 185,
            column: 6
          },
          end: {
            line: 185,
            column: 39
          }
        }],
        line: 185
      },
      "21": {
        loc: {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 33
          }
        }, {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 192,
            column: 33
          }
        }],
        line: 192
      },
      "22": {
        loc: {
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 194,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 194,
            column: 45
          }
        }, {
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 194,
            column: 45
          }
        }],
        line: 194
      },
      "23": {
        loc: {
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 198,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 198,
            column: 28
          }
        }, {
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 198,
            column: 28
          }
        }],
        line: 196
      },
      "24": {
        loc: {
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 215,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 215,
            column: 5
          }
        }, {
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 215,
            column: 5
          }
        }],
        line: 203
      },
      "25": {
        loc: {
          start: {
            line: 207,
            column: 53
          },
          end: {
            line: 207,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 207,
            column: 53
          },
          end: {
            line: 207,
            column: 62
          }
        }, {
          start: {
            line: 207,
            column: 66
          },
          end: {
            line: 207,
            column: 74
          }
        }],
        line: 207
      },
      "26": {
        loc: {
          start: {
            line: 235,
            column: 52
          },
          end: {
            line: 235,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 235,
            column: 52
          },
          end: {
            line: 235,
            column: 64
          }
        }, {
          start: {
            line: 235,
            column: 68
          },
          end: {
            line: 235,
            column: 82
          }
        }],
        line: 235
      },
      "27": {
        loc: {
          start: {
            line: 235,
            column: 84
          },
          end: {
            line: 235,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 235,
            column: 84
          },
          end: {
            line: 235,
            column: 87
          }
        }, {
          start: {
            line: 235,
            column: 91
          },
          end: {
            line: 235,
            column: 96
          }
        }],
        line: 235
      },
      "28": {
        loc: {
          start: {
            line: 238,
            column: 58
          },
          end: {
            line: 238,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 238,
            column: 58
          },
          end: {
            line: 238,
            column: 61
          }
        }, {
          start: {
            line: 238,
            column: 65
          },
          end: {
            line: 238,
            column: 70
          }
        }],
        line: 238
      },
      "29": {
        loc: {
          start: {
            line: 248,
            column: 4
          },
          end: {
            line: 250,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 248,
            column: 4
          },
          end: {
            line: 250,
            column: 5
          }
        }, {
          start: {
            line: 248,
            column: 4
          },
          end: {
            line: 250,
            column: 5
          }
        }],
        line: 248
      },
      "30": {
        loc: {
          start: {
            line: 251,
            column: 4
          },
          end: {
            line: 262,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 251,
            column: 4
          },
          end: {
            line: 262,
            column: 5
          }
        }, {
          start: {
            line: 251,
            column: 4
          },
          end: {
            line: 262,
            column: 5
          }
        }],
        line: 251
      },
      "31": {
        loc: {
          start: {
            line: 255,
            column: 53
          },
          end: {
            line: 255,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 255,
            column: 53
          },
          end: {
            line: 255,
            column: 62
          }
        }, {
          start: {
            line: 255,
            column: 66
          },
          end: {
            line: 255,
            column: 74
          }
        }],
        line: 255
      },
      "32": {
        loc: {
          start: {
            line: 281,
            column: 4
          },
          end: {
            line: 281,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 281,
            column: 4
          },
          end: {
            line: 281,
            column: 62
          }
        }, {
          start: {
            line: 281,
            column: 4
          },
          end: {
            line: 281,
            column: 62
          }
        }],
        line: 281
      },
      "33": {
        loc: {
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 281,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 281,
            column: 28
          }
        }, {
          start: {
            line: 281,
            column: 32
          },
          end: {
            line: 281,
            column: 49
          }
        }],
        line: 281
      },
      "34": {
        loc: {
          start: {
            line: 290,
            column: 10
          },
          end: {
            line: 290,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 290,
            column: 10
          },
          end: {
            line: 290,
            column: 31
          }
        }, {
          start: {
            line: 290,
            column: 35
          },
          end: {
            line: 290,
            column: 46
          }
        }, {
          start: {
            line: 290,
            column: 50
          },
          end: {
            line: 290,
            column: 60
          }
        }],
        line: 290
      },
      "35": {
        loc: {
          start: {
            line: 291,
            column: 10
          },
          end: {
            line: 291,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 291,
            column: 10
          },
          end: {
            line: 291,
            column: 17
          }
        }, {
          start: {
            line: 291,
            column: 21
          },
          end: {
            line: 291,
            column: 26
          }
        }],
        line: 291
      },
      "36": {
        loc: {
          start: {
            line: 303,
            column: 12
          },
          end: {
            line: 303,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 303,
            column: 12
          },
          end: {
            line: 303,
            column: 18
          }
        }, {
          start: {
            line: 303,
            column: 22
          },
          end: {
            line: 303,
            column: 32
          }
        }],
        line: 303
      },
      "37": {
        loc: {
          start: {
            line: 304,
            column: 12
          },
          end: {
            line: 304,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 304,
            column: 12
          },
          end: {
            line: 304,
            column: 47
          }
        }, {
          start: {
            line: 304,
            column: 51
          },
          end: {
            line: 304,
            column: 62
          }
        }],
        line: 304
      },
      "38": {
        loc: {
          start: {
            line: 309,
            column: 10
          },
          end: {
            line: 313,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 309,
            column: 10
          },
          end: {
            line: 313,
            column: 11
          }
        }, {
          start: {
            line: 309,
            column: 10
          },
          end: {
            line: 313,
            column: 11
          }
        }],
        line: 309
      },
      "39": {
        loc: {
          start: {
            line: 310,
            column: 32
          },
          end: {
            line: 310,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 310,
            column: 53
          },
          end: {
            line: 310,
            column: 66
          }
        }, {
          start: {
            line: 310,
            column: 69
          },
          end: {
            line: 310,
            column: 91
          }
        }],
        line: 310
      },
      "40": {
        loc: {
          start: {
            line: 315,
            column: 17
          },
          end: {
            line: 339,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 316,
            column: 12
          },
          end: {
            line: 328,
            column: 14
          }
        }, {
          start: {
            line: 330,
            column: 12
          },
          end: {
            line: 338,
            column: 14
          }
        }],
        line: 315
      },
      "41": {
        loc: {
          start: {
            line: 333,
            column: 23
          },
          end: {
            line: 333,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 333,
            column: 23
          },
          end: {
            line: 333,
            column: 50
          }
        }, {
          start: {
            line: 333,
            column: 54
          },
          end: {
            line: 333,
            column: 61
          }
        }],
        line: 333
      },
      "42": {
        loc: {
          start: {
            line: 352,
            column: 53
          },
          end: {
            line: 352,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 352,
            column: 53
          },
          end: {
            line: 352,
            column: 62
          }
        }, {
          start: {
            line: 352,
            column: 66
          },
          end: {
            line: 352,
            column: 72
          }
        }],
        line: 352
      },
      "43": {
        loc: {
          start: {
            line: 356,
            column: 4
          },
          end: {
            line: 356,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 356,
            column: 4
          },
          end: {
            line: 356,
            column: 51
          }
        }, {
          start: {
            line: 356,
            column: 4
          },
          end: {
            line: 356,
            column: 51
          }
        }],
        line: 356
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Dropdown/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import { defaultProps } from '../utils/defaultProps';
import { getParent } from '../utils/dom/element';
import Button from '../Button';
import { dropdownClass } from './styles';
import List from '../AnimationList';
import Item from './Item';
import { docSize } from '../utils/dom/document';
import absoluteList from '../AnimationList/AbsoluteList';
import { getUidStr } from '../utils/uid';
import { isFunc } from '../utils/is';
import absoluteComsumer from '../Table/context';
import Caret from '../icons/Caret';
import { isRTL } from '../config';
import { getDirectionClass } from '../utils/classname';
import getDataset from '../utils/dom/getDataset';
var positionMap = (cov_k5j169vhi.s[0]++, {
  'left-top': 'left-top',
  'left-bottom': 'left-bottom',
  'right-top': 'right-top',
  'right-bottom': 'right-bottom',
  'top-right': 'left-bottom',
  'top-left': 'right-bottom',
  'bottom-right': 'left-top',
  'bottom-left': 'right-top',
  auto: ''
});
var DefaultProps = (cov_k5j169vhi.s[1]++, _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  data: [],
  animation: true,
  disabled: false,
  trigger: 'click',
  position: 'bottom-left'
}));

var Dropdown =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Dropdown, _PureComponent);

  var _super = _createSuper2(Dropdown);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    cov_k5j169vhi.f[0]++;
    cov_k5j169vhi.s[2]++;
    _this = _super.call(this, props);
    _this.dropdownId = void 0;
    _this.handleMouseEnter = void 0;
    _this.handleMouseLeave = void 0;
    _this.element = void 0;
    _this.DropdownList = void 0;
    _this.closeTimer = void 0;
    _this.focus = void 0;
    _this.lastFoucs = void 0;
    cov_k5j169vhi.s[3]++;
    _this.state = {
      show: false // @ts-ignore

    };
    cov_k5j169vhi.s[4]++;

    if (props.hover !== undefined) {
      cov_k5j169vhi.b[0][0]++;
      cov_k5j169vhi.s[5]++;
      console.warn('The "hover" property is not recommend, use trigger="hover" instead.');
    } else {
      cov_k5j169vhi.b[0][1]++;
    }

    cov_k5j169vhi.s[6]++;
    _this.dropdownId = "dropdown_".concat(getUidStr());
    cov_k5j169vhi.s[7]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_k5j169vhi.s[8]++;
    _this.clickAway = _this.clickAway.bind(_assertThisInitialized(_this));
    cov_k5j169vhi.s[9]++;
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    cov_k5j169vhi.s[10]++;
    _this.handleHide = _this.handleHide.bind(_assertThisInitialized(_this));
    cov_k5j169vhi.s[11]++;
    _this.handleMouseEnter = _this.handleToggle.bind(_assertThisInitialized(_this), true);
    cov_k5j169vhi.s[12]++;
    _this.handleMouseLeave = _this.handleToggle.bind(_assertThisInitialized(_this), false);
    cov_k5j169vhi.s[13]++;
    _this.renderList = _this.renderList.bind(_assertThisInitialized(_this));
    cov_k5j169vhi.s[14]++;

    _this.bindList();

    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_k5j169vhi.f[1]++;
      cov_k5j169vhi.s[15]++;

      _get(_getPrototypeOf(Dropdown.prototype), "componentDidMount", this).call(this);

      cov_k5j169vhi.s[16]++;
      this.setOpenEvent();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      cov_k5j169vhi.f[2]++;
      cov_k5j169vhi.s[17]++;
      this.setOpenEvent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_k5j169vhi.f[3]++;
      cov_k5j169vhi.s[18]++;

      _get(_getPrototypeOf(Dropdown.prototype), "componentWillUnmount", this).call(this);

      cov_k5j169vhi.s[19]++;
      this.toggleDocumentEvent(false);
    }
  }, {
    key: "setOpenEvent",
    value: function setOpenEvent() {
      cov_k5j169vhi.f[5]++;
      cov_k5j169vhi.s[23]++;

      if (this.lastFoucs !== this.show) {
        cov_k5j169vhi.b[2][0]++;
        cov_k5j169vhi.s[24]++;

        if (this.show) {
          cov_k5j169vhi.b[3][0]++;
          cov_k5j169vhi.s[25]++;
          this.toggleDocumentEvent(true);
        } else {
          cov_k5j169vhi.b[3][1]++;
          cov_k5j169vhi.s[26]++;

          if (this.lastFoucs !== undefined) {
            cov_k5j169vhi.b[4][0]++;
            cov_k5j169vhi.s[27]++;
            this.toggleDocumentEvent(false);
          } else {
            cov_k5j169vhi.b[4][1]++;
          }
        }
      } else {
        cov_k5j169vhi.b[2][1]++;
      }

      cov_k5j169vhi.s[28]++;
      this.lastFoucs = this.show;
    }
  }, {
    key: "getTrigger",
    value: function getTrigger() {
      cov_k5j169vhi.f[6]++;
      cov_k5j169vhi.s[29]++;

      // @ts-ignore
      if (this.props.hover === true) {
        cov_k5j169vhi.b[5][0]++;
        cov_k5j169vhi.s[30]++;
        return 'hover';
      } else {
        cov_k5j169vhi.b[5][1]++;
      }

      cov_k5j169vhi.s[31]++;
      return this.props.trigger;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      cov_k5j169vhi.f[7]++;

      var _ref = (cov_k5j169vhi.s[32]++, this.props),
          position = _ref.position;

      cov_k5j169vhi.s[33]++;

      if (position !== 'auto') {
        cov_k5j169vhi.b[6][0]++;
        cov_k5j169vhi.s[34]++;
        return position;
      } else {
        cov_k5j169vhi.b[6][1]++;
      }

      cov_k5j169vhi.s[35]++;

      if (!this.element) {
        cov_k5j169vhi.b[7][0]++;
        cov_k5j169vhi.s[36]++;
        return 'bottom-left';
      } else {
        cov_k5j169vhi.b[7][1]++;
      }

      var windowHeight = (cov_k5j169vhi.s[37]++, docSize.height);
      var windowWidth = (cov_k5j169vhi.s[38]++, docSize.width);
      var rect = (cov_k5j169vhi.s[39]++, this.element.getBoundingClientRect());
      var prefix = (cov_k5j169vhi.s[40]++, rect.bottom > windowHeight / 2 ? (cov_k5j169vhi.b[8][0]++, 'top-') : (cov_k5j169vhi.b[8][1]++, 'bottom-'));
      var suffix = (cov_k5j169vhi.s[41]++, rect.right > windowWidth / 2 ? (cov_k5j169vhi.b[9][0]++, 'right') : (cov_k5j169vhi.b[9][1]++, 'left'));
      cov_k5j169vhi.s[42]++;
      position = prefix + suffix;
      cov_k5j169vhi.s[43]++;
      return position;
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_k5j169vhi.f[8]++;
      cov_k5j169vhi.s[44]++;
      this.element = el;
    }
  }, {
    key: "bindList",
    value: function bindList() {
      var _this2 = this;

      cov_k5j169vhi.f[9]++;

      var _ref2 = (cov_k5j169vhi.s[45]++, this.props),
          animation = _ref2.animation;

      var FadeList = (cov_k5j169vhi.s[46]++, List('fade', animation ? (cov_k5j169vhi.b[10][0]++, 'fast') : (cov_k5j169vhi.b[10][1]++, 0))); // @ts-ignore

      cov_k5j169vhi.s[47]++;
      this.DropdownList = absoluteList(function (_ref3) {
        var focus = _ref3.focus,
            other = _objectWithoutProperties(_ref3, ["focus"]);

        cov_k5j169vhi.f[10]++;
        cov_k5j169vhi.s[48]++;
        return (
          /*#__PURE__*/
          React.createElement(FadeList, Object.assign({
            show: focus
          }, other, {
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 152,
              columnNumber: 63
            }
          }))
        );
      });
    }
  }, {
    key: "toggleDocumentEvent",
    value: function toggleDocumentEvent(bind) {
      cov_k5j169vhi.f[11]++;
      var method = (cov_k5j169vhi.s[49]++, bind ? (cov_k5j169vhi.b[11][0]++, 'addEventListener') : (cov_k5j169vhi.b[11][1]++, 'removeEventListener'));
      cov_k5j169vhi.s[50]++;
      document[method]('mousedown', this.clickAway, true);
    }
  }, {
    key: "clickAway",
    value: function clickAway(e) {
      cov_k5j169vhi.f[12]++;

      var _ref4 = (cov_k5j169vhi.s[51]++, this.props),
          absolute = _ref4.absolute;

      var el = (cov_k5j169vhi.s[52]++, getParent(e.target, 'a'));
      var onSelf = (cov_k5j169vhi.s[53]++, absolute ? (cov_k5j169vhi.b[12][0]++, getParent(e.target, "[data-id=".concat(this.dropdownId, "]"))) : (cov_k5j169vhi.b[12][1]++, (cov_k5j169vhi.b[13][0]++, el === this.element) || (cov_k5j169vhi.b[13][1]++, this.element.contains(el))));
      cov_k5j169vhi.s[54]++;

      if ((cov_k5j169vhi.b[15][0]++, el) && (cov_k5j169vhi.b[15][1]++, onSelf) && (cov_k5j169vhi.b[15][2]++, el.getAttribute('data-role') === 'item')) {
        cov_k5j169vhi.b[14][0]++;
        cov_k5j169vhi.s[55]++;
        return;
      } else {
        cov_k5j169vhi.b[14][1]++;
      }

      cov_k5j169vhi.s[56]++;
      this.handleHide(0);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      cov_k5j169vhi.f[13]++;

      var _ref5 = (cov_k5j169vhi.s[57]++, this.props),
          onCollapse = _ref5.onCollapse;

      cov_k5j169vhi.s[58]++;

      if (this.closeTimer) {
        cov_k5j169vhi.b[16][0]++;
        cov_k5j169vhi.s[59]++;
        clearTimeout(this.closeTimer);
      } else {
        cov_k5j169vhi.b[16][1]++;
      }

      cov_k5j169vhi.s[60]++;

      if (this.show) {
        cov_k5j169vhi.b[17][0]++;
        cov_k5j169vhi.s[61]++;
        return;
      } else {
        cov_k5j169vhi.b[17][1]++;
      }

      cov_k5j169vhi.s[62]++;

      if (onCollapse) {
        cov_k5j169vhi.b[18][0]++;
        cov_k5j169vhi.s[63]++;
        onCollapse(true);
      } else {
        cov_k5j169vhi.b[18][1]++;
      }

      cov_k5j169vhi.s[64]++;
      this.setState({
        show: true
      });
    }
  }, {
    key: "handleHide",
    value: function handleHide() {
      var _this3 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_k5j169vhi.b[19][0]++, 200);
      cov_k5j169vhi.f[14]++;

      var _ref6 = (cov_k5j169vhi.s[65]++, this.props),
          onCollapse = _ref6.onCollapse;

      cov_k5j169vhi.s[66]++;
      this.closeTimer = setTimeout(function () {
        cov_k5j169vhi.f[15]++;
        cov_k5j169vhi.s[67]++;

        if (onCollapse) {
          cov_k5j169vhi.b[20][0]++;
          cov_k5j169vhi.s[68]++;
          onCollapse(false);
        } else {
          cov_k5j169vhi.b[20][1]++;
        }

        cov_k5j169vhi.s[69]++;

        _this3.setState({
          show: false
        });
      }, delay);
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(show) {
      cov_k5j169vhi.f[16]++;

      var _ref7 = (cov_k5j169vhi.s[70]++, this.props),
          disabled = _ref7.disabled;

      cov_k5j169vhi.s[71]++;

      if (disabled === true) {
        cov_k5j169vhi.b[21][0]++;
        cov_k5j169vhi.s[72]++;
        return;
      } else {
        cov_k5j169vhi.b[21][1]++;
      }

      cov_k5j169vhi.s[73]++;

      if (this.getTrigger() === 'click') {
        cov_k5j169vhi.b[22][0]++;
        cov_k5j169vhi.s[74]++;
        return;
      } else {
        cov_k5j169vhi.b[22][1]++;
      }

      cov_k5j169vhi.s[75]++;

      if (show) {
        cov_k5j169vhi.b[23][0]++;
        cov_k5j169vhi.s[76]++;
        this.handleFocus();
      } else {
        cov_k5j169vhi.b[23][1]++;
        cov_k5j169vhi.s[77]++;
        this.handleHide();
      }
    }
  }, {
    key: "renderRTLButton",
    value: function renderRTLButton(placeholder, spanClassName, caret, buttonClassName) {
      cov_k5j169vhi.f[17]++;

      var _ref8 = (cov_k5j169vhi.s[78]++, this.props),
          isSub = _ref8.isSub,
          type = _ref8.type,
          outline = _ref8.outline,
          size = _ref8.size,
          disabled = _ref8.disabled;

      cov_k5j169vhi.s[79]++;

      if (isSub) {
        cov_k5j169vhi.b[24][0]++;
        cov_k5j169vhi.s[80]++;
        return (
          /*#__PURE__*/
          React.createElement("a", {
            key: "button",
            className: dropdownClass('button', 'item', (cov_k5j169vhi.b[25][0]++, this.show) && (cov_k5j169vhi.b[25][1]++, 'active')),
            "data-role": "item",
            onClick: this.handleFocus,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 205,
              columnNumber: 9
            }
          },
          /*#__PURE__*/
          React.createElement("span", {
            className: spanClassName,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 211,
              columnNumber: 11
            }
          }, placeholder), caret)
        );
      } else {
        cov_k5j169vhi.b[24][1]++;
      }

      cov_k5j169vhi.s[81]++;
      return (
        /*#__PURE__*/
        React.createElement(Button, {
          disabled: disabled,
          onClick: this.handleFocus,
          outline: outline,
          className: buttonClassName,
          type: type,
          size: size,
          key: "button",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 217,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          className: spanClassName,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 226,
            columnNumber: 9
          }
        }, placeholder), caret)
      );
    }
  }, {
    key: "renderButton",
    value: function renderButton(placeholder) {
      cov_k5j169vhi.f[18]++;

      var _ref9 = (cov_k5j169vhi.s[82]++, this.props),
          type = _ref9.type,
          outline = _ref9.outline,
          size = _ref9.size,
          disabled = _ref9.disabled,
          isSub = _ref9.isSub,
          position = _ref9.position;

      var rtl = (cov_k5j169vhi.s[83]++, isRTL());
      var buttonClassName = (cov_k5j169vhi.s[84]++, dropdownClass('button', (cov_k5j169vhi.b[26][0]++, !placeholder) && (cov_k5j169vhi.b[26][1]++, 'split-button'), (cov_k5j169vhi.b[27][0]++, rtl) && (cov_k5j169vhi.b[27][1]++, 'rtl')));
      var spanClassName = (cov_k5j169vhi.s[85]++, dropdownClass('button-content'));
      var caret = (cov_k5j169vhi.s[86]++,
      /*#__PURE__*/
      React.createElement("span", {
        key: "caret",
        className: dropdownClass('caret', (cov_k5j169vhi.b[28][0]++, rtl) && (cov_k5j169vhi.b[28][1]++, 'rtl')),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 238,
          columnNumber: 7
        }
      },
      /*#__PURE__*/
      React.createElement(Caret, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 239,
          columnNumber: 9
        }
      })));
      var childs = (cov_k5j169vhi.s[87]++, [
      /*#__PURE__*/
      React.createElement("span", {
        key: "text",
        className: spanClassName,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 243,
          columnNumber: 7
        }
      }, placeholder), caret]);
      cov_k5j169vhi.s[88]++;

      if (['left-bottom', 'left-top'].includes(position)) {
        cov_k5j169vhi.b[29][0]++;
        cov_k5j169vhi.s[89]++;
        childs.reverse();
      } else {
        cov_k5j169vhi.b[29][1]++;
      }

      cov_k5j169vhi.s[90]++;

      if (isSub) {
        cov_k5j169vhi.b[30][0]++;
        cov_k5j169vhi.s[91]++;
        return (
          /*#__PURE__*/
          React.createElement("a", {
            key: "button",
            className: dropdownClass('button', 'item', (cov_k5j169vhi.b[31][0]++, this.show) && (cov_k5j169vhi.b[31][1]++, 'active')),
            "data-role": "item",
            onClick: this.handleFocus,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 253,
              columnNumber: 9
            }
          }, childs)
        );
      } else {
        cov_k5j169vhi.b[30][1]++;
      }

      cov_k5j169vhi.s[92]++;
      return (
        /*#__PURE__*/
        React.createElement(Button, {
          disabled: disabled,
          onClick: this.handleFocus,
          outline: outline,
          className: buttonClassName,
          type: type,
          size: size,
          key: "button",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 265,
            columnNumber: 7
          }
        }, childs)
      );
    }
  }, {
    key: "renderList",
    value: function renderList(data, placeholder, position) {
      var _this4 = this;

      cov_k5j169vhi.f[19]++;

      var _ref10 = (cov_k5j169vhi.s[93]++, this.props),
          width = _ref10.width,
          onClick = _ref10.onClick,
          columns = _ref10.columns,
          renderItem = _ref10.renderItem,
          absolute = _ref10.absolute;

      cov_k5j169vhi.s[94]++;

      if ((cov_k5j169vhi.b[33][0]++, !Array.isArray(data)) || (cov_k5j169vhi.b[33][1]++, data.length === 0)) {
        cov_k5j169vhi.b[32][0]++;
        cov_k5j169vhi.s[95]++;
        return null;
      } else {
        cov_k5j169vhi.b[32][1]++;
      }

      var _ref11 = (cov_k5j169vhi.s[96]++, this),
          DropdownList = _ref11.DropdownList;

      cov_k5j169vhi.s[97]++;
      return [
      /*#__PURE__*/
      React.createElement(DropdownList, {
        absolute: absolute,
        parentElement: this.element,
        position: position,
        className: dropdownClass(getDirectionClass('menu'), (cov_k5j169vhi.b[34][0]++, columns !== undefined) && (cov_k5j169vhi.b[34][1]++, columns > 1) && (cov_k5j169vhi.b[34][2]++, 'box-list'), (cov_k5j169vhi.b[35][0]++, isRTL()) && (cov_k5j169vhi.b[35][1]++, 'rtl')),
        style: {
          width: width
        },
        key: "list",
        focus: this.show,
        "data-id": this.dropdownId,
        fixed: "min",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 284,
          columnNumber: 7
        }
      }, data.map(function (d, index) {
        cov_k5j169vhi.f[20]++;
        var childPosition = (cov_k5j169vhi.s[98]++, positionMap[position]);
        var itemClassName = (cov_k5j169vhi.s[99]++, dropdownClass('item', (cov_k5j169vhi.b[36][0]++, !width) && (cov_k5j169vhi.b[36][1]++, 'no-width'), (cov_k5j169vhi.b[37][0]++, childPosition.indexOf('left') === 0) && (cov_k5j169vhi.b[37][1]++, 'item-left')));
        var renderPlaceholder;
        cov_k5j169vhi.s[100]++;

        if (renderItem) {
          cov_k5j169vhi.b[38][0]++;
          cov_k5j169vhi.s[101]++;
          renderPlaceholder = isFunc(renderItem) ? (cov_k5j169vhi.b[39][0]++, renderItem(d)) : (cov_k5j169vhi.b[39][1]++, d[renderItem]);
        } else {
          cov_k5j169vhi.b[38][1]++;
          cov_k5j169vhi.s[102]++;
          renderPlaceholder = d.content;
        }

        var _ref12 = (cov_k5j169vhi.s[103]++, d),
            children = _ref12.children;

        cov_k5j169vhi.s[104]++;
        return children ? (cov_k5j169vhi.b[40][0]++,
        /*#__PURE__*/
        React.createElement(Dropdown, {
          style: {
            width: '100%'
          },
          data: children,
          disabled: !!d.disabled,
          placeholder: renderPlaceholder,
          type: "link",
          key: index,
          position: childPosition,
          onClick: onClick,
          renderItem: renderItem,
          trigger: _this4.getTrigger(),
          isSub: true,
          __self: _this4,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 316,
            columnNumber: 13
          }
        })) : (cov_k5j169vhi.b[40][1]++,
        /*#__PURE__*/
        React.createElement(Item, {
          data: d,
          key: index,
          onClick: (cov_k5j169vhi.b[41][0]++, d.onClick) || (cov_k5j169vhi.b[41][1]++, onClick),
          itemClassName: itemClassName,
          renderItem: renderItem,
          columns: columns,
          width: width,
          __self: _this4,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 330,
            columnNumber: 13
          }
        }));
      })), this.renderButton(placeholder)];
    }
  }, {
    key: "render",
    value: function render() {
      cov_k5j169vhi.f[21]++;

      var _ref13 = (cov_k5j169vhi.s[105]++, this.props),
          data = _ref13.data,
          className = _ref13.className,
          style = _ref13.style,
          placeholder = _ref13.placeholder; // const { show } = this.state


      var position = (cov_k5j169vhi.s[106]++, this.getPosition());
      var wrapClassName = (cov_k5j169vhi.s[107]++, dropdownClass('_', position, (cov_k5j169vhi.b[42][0]++, this.show) && (cov_k5j169vhi.b[42][1]++, 'show'), {
        'split-dropdown': !placeholder,
        rtl: isRTL()
      }));
      cov_k5j169vhi.s[108]++;

      if (className) {
        cov_k5j169vhi.b[43][0]++;
        cov_k5j169vhi.s[109]++;
        wrapClassName += " ".concat(className);
      } else {
        cov_k5j169vhi.b[43][1]++;
      }

      cov_k5j169vhi.s[110]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          ref: this.bindElement,
          className: wrapClassName,
          style: style,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }, getDataset(this.props), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 359,
            columnNumber: 7
          }
        }), this.renderList(data, placeholder, position))
      );
    }
  }, {
    key: "show",
    get: function get() {
      cov_k5j169vhi.f[4]++;
      cov_k5j169vhi.s[20]++;

      if ('open' in this.props) {
        cov_k5j169vhi.b[1][0]++;
        cov_k5j169vhi.s[21]++;
        return !!this.props.open;
      } else {
        cov_k5j169vhi.b[1][1]++;
      }

      cov_k5j169vhi.s[22]++;
      return this.state.show;
    }
  }]);

  return Dropdown;
}(PureComponent);

Dropdown.defaultProps = DefaultProps;
Dropdown.displayName = void 0;
cov_k5j169vhi.s[111]++;
Dropdown.displayName = 'ShineoutDropdown';
var exports = (cov_k5j169vhi.s[112]++, absoluteComsumer(Dropdown));
export default exports;